import React from 'react';
import { useTranslate } from '../../mixins/translate/translate';

function statusToClassName(status: string) {
    switch (status) {
        case '1':
            return 'label-info';
        case '2':
            return 'label-warning';
        case '3':
            return 'label-danger';
        default:
            return 'label-muted';
    }
}

export function InvestigationPriorityLabel(props: { value?: string | number | undefined | null }) {
    const translate = useTranslate();

    if (!props.value) {
        return null;
    }
    const text = translate(`investigationPriority.${props.value}`);
    return (
        <span className={`label ${statusToClassName(props.value.toString())}`} title={text}>
            {text}
        </span>
    );
}
